import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-unsubscribe',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatCardModule
  ],
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.scss'
})
export class UnsubscribeComponent {
  unsubscribeForm = new FormGroup({
    followUpReminders: new FormControl(false),
    healthNewsletters: new FormControl(false),
    unsubscribeAll: new FormControl(false),
  });

  unsubscribe() {
    const preferences = this.unsubscribeForm.value;
    // Here, send the unsubscribe request to the backend
    // This can include an HTTP request with the selected preferences and a token or ID passed in the URL
  }

}
